<template>
	<div>
		<vendor-gst-modal :gstData="vendorDetails"
																				:isView="show"
																				@gstDataSubmit="gstDataSubmit($event)"
																				@gstModalClose="clearGstFormData"
		>
		</vendor-gst-modal>

		<div class="dashboard-card">
			<div class="dashbord-tag failed"
								:style="(getStatusData.request_status ==='REQUEST ACCEPTED')?
         '    background-color: green;':
         (getStatusData.request_status ==='REQUEST PROCESSING')?
         '    background-color: yellow;color:black;':
         '    background-color: red;'"
								data-test="vendorBankDetailsDashboardGstStatus"
								id="vendorBankDetailsDashboardGstStatus"
			>
				{{(getStatusData.request_status ==='REQUEST ACCEPTED')?
				'Verified':
				(getStatusData.request_status ==='REQUEST PROCESSING')?
				'Unverified':
				'Verification Failed'}}
			</div>
			{{isBankDetailsNull}}
			<div class="card-details"
								v-if="!isBankDetailsNull"
			>
				<p data-test="vendorBankDetailsDashboardAccHolderNameLabel"
							id="vendorBankDetailsDashboardAccHolderNameLabel">
					Account Holder Name:
					<span data-test="vendorBankDetailsDashboardAccHolderName"
											id="vendorBankDetailsDashboardAccHolderName">
          {{vendorDetails.account_holder_name}}
        </span>
				</p>
				<p data-test="vendorBankDetailsDashboardBnkNameLabel"
							id="vendorBankDetailsDashboardBnkNameLabel">
					Bank Name:
					<span data-test="vendorBankDetailsDashboardBnkName"
											id="vendorBankDetailsDashboardBnkName">
            {{vendorDetails.bank_name}}
          </span>
				</p>
				<p data-test="vendorBankDetailsDashboardBrnchNameLabel"
							id="vendorBankDetailsDashboardBrnchNameLabel">
					Branch Name:
					<span data-test="vendorBankDetailsDashboardBrnchName"
											id="vendorBankDetailsDashboardBrnchName">
            {{vendorDetails.branch_name}}
          </span>
				</p>
				<p data-test="vendorBankDetailsDashboardIfscCodeLabel"
							id="vendorBankDetailsDashboardIfscCodeLabel">
					Ifsc Code:
					<span data-test="vendorBankDetailsDashboardIfscCode"
											id="vendorBankDetailsDashboardIfscCode">
            {{vendorDetails.ifsc_code}}
          </span>
				</p>
			</div>
			<div class="card-details text-center"
								v-else
								data-test="vendorBankDetailsDashboardAddNew"
								id="vendorBankDetailsDashboardAddNew"
			>
				Add bank details
			</div>
			<!-- action -->
			<div class="card-actions"
								v-if="!isBankDetailsNull"
			>
				<a type="button"
							class="btn btn-primary btn-type-primary"
							@click="variableEdit"
							data-test="vendorBankDetailsDashboardEditLink"
							id="vendorBankDetailsDashboardEditLink"
				>
					Edit
				</a>
				<a type="button"
							class="btn btn-primary btn-type-primary"
							@click="variableView"
							data-test="vendorBankDetailsDashboardViewLink"
							id="vendorBankDetailsDashboardViewLink"
				>
					View
				</a>
			</div>
			<div class="card-actions"
								v-else
			>
				<a type="button"
							class="btn btn-primary btn-type-primary"
							@click="variableAdd"
							data-test="vendorBankDetailsDashboardAddLink"
							id="vendorBankDetailsDashboardAddLink"
				>
					Add
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import VendorGstModal from '../../modals/vendorGstModal'
import { vendorApis } from '../../../../../services/ApiServices/vendorApis'

export default {
	components: { VendorGstModal },
	name: 'vendor-bank-details-dashboard',
	computed: {
		...mapGetters('vendor', ['getStatusData'])
	},
	data () {
		return {
			account: {},
			isBankDetailsNull: true,
			vendorDetails: {},
			show: false
		}
	},
	// props: {
	//   gstApproval: {
	//     type: Boolean,
	//     default: false,
	//   },
	// },
	mounted () {
		this.getVendorAccountDetails()
	},
	methods: {
		variableAdd () {
			$('#gstModal')
				.modal('show')
		},
		gstDataSubmit (data) {
			vendorApis.vendorAccountInformation(data)
				.then((res) => {
					// this.gstApproval = true;
					this.$toasted.show('Successfully added bank Details')
					$('#gstModal').modal('hide')
					this.getVendorAccountDetails()
				})
		},
		getVendorAccountDetails () {
			vendorApis.vendorInfo()
				.then((res) => {
					if (res.data.account_details !== null) {
						this.isBankDetailsNull = false
						this.vendorDetails = res.data.account_details
					} else {
						this.isBankDetailsNull = true
						this.vendorDetails = {
							account_number: '',
							account_holder_name: '',
							pancard_number: ''
						}
					}
				})
		},
		variableView () {
			this.show = true
			$('#gstModal')
				.modal('show')
		},
		variableEdit () {
			this.show = false
			$('#gstModal')
				.modal('show')
		},
		clearGstFormData () {
			this.getVendorAccountDetails()
		}
	}
}
</script>

<style scoped>

</style>
